const AccountSectionFeaturesEnum = {
  CORPORATE_DASHBOARD: 'CORPORATE_DASHBOARD',
  CORPORATE_ALERTS   : 'CORPORATE_ALERTS',
  CORPORATE_RISK     : 'CORPORATE_RISK',
  CORPORATE_HEDGING  : 'CORPORATE_HEDGING',
  CORPORATE_INDUSTRY : 'CORPORATE_INDUSTRY',
  CORPORATE_POSITIONS: 'CORPORATE_POSITIONS',
  CORPORATE_AGENT    : 'CORPORATE_AGENT',
  BANKING_DASHBOARD  : 'BANKING_DASHBOARD',
  BANKING_ALM        : 'BANKING_ALM',
  BANKING_RATES      : 'BANKING_RATES',
  BANKING_RISK       : 'BANKING_RISK',
  BANKING_HEDGING    : 'BANKING_HEDGING'
}

export default AccountSectionFeaturesEnum
